import { Exception } from '../../utilities/index.js';
export class CommandMapper {
    static $type = 'command-mapper';
    _mappings = {};
    registerMappingCommandToSnapshot(cmdType, factory) {
        let mapping = this._mappings[cmdType];
        if (!mapping) {
            mapping = {};
        }
        mapping.commandToSnapshot = factory;
        this._mappings[cmdType] = mapping;
    }
    registerMappingSnapshotToCommand(cmdType, factory) {
        let mapping = this._mappings[cmdType];
        if (!mapping) {
            mapping = {};
        }
        mapping.snapshotToCommand = factory;
        this._mappings[cmdType] = mapping;
    }
    mapCommandToSnapshot(cmd) {
        const mapping = this._mappings[cmd.$type];
        if (!mapping || !mapping.commandToSnapshot) {
            throw new Exception(`No mapping registered for command type ${cmd.$type}`);
        }
        const snapshot = mapping.commandToSnapshot(cmd);
        return snapshot;
    }
    mapSnapshotToCommand(snapshot) {
        const mapping = this._mappings[snapshot.$type];
        if (!mapping || !mapping.snapshotToCommand) {
            throw new Exception(`No mapping snapshot-to-command registered for command type ${snapshot.$type}`);
        }
        const command = mapping.snapshotToCommand(snapshot);
        return command;
    }
}
//# sourceMappingURL=command-mapper.js.map